<template>
  <div>
    <v-breadcrumb />

    <h2>Exploitant</h2>
    <FormExploitant v-if="!hasExploitant" title="Association à un exploitant" v-model="newExploitant" ref="form">
      <v-error-ct :error="error" />
      <button class="primary-action flex-12 btn-icon" @click="addOrUpdate" :disabled="errors.items.length !== 0">
        Associer à l'exploitant
      </button>
    </FormExploitant>
    <FormExploitant v-else title="Information de l'exploitant" :exploitant="exploitant" v-model="newExploitant">
      <v-error-ct :error="error" />
      <button class="primary-action flex-12 btn-icon" @click="addOrUpdate"
              :disabled="errors.items.length !== 0 && hasEmptyChamp">Modifier l'exploitant
      </button>
    </FormExploitant>
  </div>
</template>

<script>

import FormExploitant from './FormExploitant'
import { addExploitant, updateExploitant } from '@/api/client-api'
import { SET_INFORMATION } from '@/store/mutation-types'
import information from "@/views/exploitation/Information.vue";

export default {
  name: 'ExploitationExploitant',

  inject: ['$validator'],

  components: {
    FormExploitant
  },

  data() {
    return {
      error: null,
      newExploitant: {
        nom: null,
        prenom: null,
        email: null
      }
    }
  },

  computed: {
    information() {
      return this.$store.state.exploitation.information || {}
    },

    idExploitant() {
      return this.information.id_exploitant
    },

    hasExploitant() {
      return this.idExploitant !== null
    },

    exploitant() {
      return {
        nom: this.information.exploitant_nom,
        prenom: this.information.exploitant_prenom,
        email: this.information.exploitant_email
      }
    }
  },

  methods: {
    associer () {
      addExploitant(this.information.id_exploitation, this.newExploitant)
        .then(information => {
          this.updateStoreInfo(information, 'add');
        })
        .catch(err => {
          this.error = err.response.data
        })
    },
    modifier () {
      // On test uniquement le nom car si un seul champ est modifié l'ensemble de l'objet est set avec les infos de l'exploitant
      if (this.newExploitant.nom === null) {
        return
      }
      updateExploitant(this.information.id_exploitation, this.information.id_exploitant, this.newExploitant)
        .then(information => {
          this.updateStoreInfo(information, 'update');
        })
        .catch(err => {
          this.error = err.response.data
        })
    },
    addOrUpdate () {
      this.error = null
      this.$validator.validateScopes().then(() => {
        if (this.exploitant.nom == null) {
          this.associer()
        } else {
          this.modifier()
        }
      })
    },
    updateStoreInfo (information, method) {
      this.$store.commit(SET_INFORMATION, information)
      if (method === 'update') {
        this.$store.dispatch('success', {message: "Informations de l'exploitant modifiées avec succès."})
      } else if (method === 'add') {
        this.$store.dispatch('success', {message: "Exploitant associé avec succès."})
      }
    },
    hasEmptyChamp () {
      return this.newExploitant.nom === '' || this.newExploitant.prenom === '' || this.newExploitant.email === '';
    }
  }
}
</script>
